// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import * as TowUtils from '../../utils/game/TowServiceUtils';

/**
 * Custom hook for tow service completion and fuel restoration
 * Extracted from NavigationPanel to reduce file size
 */
export const useTowService = ({
  towOfferData,
  enrichLocationWithCoordinates,
  generatePlanetStars,
  setCurrentLocation,
  setSelectedSystem,
  setFuelDirect,
  setFuelDepleted,
  setTowOfferData,
  setTowDestination,
  setShowTowAnimation,
  setShowArrivalScreen,
  setShowOrbitScreen,
  setHasArrived,
  setPlanetStars,
  setActiveEvent
}) => {
  const handleTowComplete = () => {
    if (!towOfferData) return;

    const { nearestStar } = towOfferData;
    const towRefuelPercent = TowUtils.getTowRefuelPercent();

    setShowTowAnimation(false);
    setTowDestination(null);

    setTimeout(() => {
      setCurrentLocation(enrichLocationWithCoordinates(TowUtils.createTowDestinationLocation(nearestStar)));
      setFuelDirect(towRefuelPercent);
      setFuelDepleted(false);
      setActiveEvent(null);
      setTowOfferData(null);
      setSelectedSystem(nearestStar);
      setHasArrived(true);
      setShowArrivalScreen(false);
      setShowOrbitScreen(true);
      setPlanetStars(generatePlanetStars());
    }, 2000);
  };

  return { handleTowComplete };
};
